import * as React from "react";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "./dialog";

/**
 * `FormDialog` is the canonical modal for form fields: it wraps Radix `Dialog` and standardises
 * title, optional description, body and footer. The `footer` slot is a `ReactNode` rather than a
 * fixed submit/cancel API because labels, disabled state and pending text vary too much. Keep this
 * API at six props or fewer — past a single body and footer slot, drop to raw `Dialog`.
 */
export interface FormDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: React.ReactNode;
  children: React.ReactNode;
  footer: React.ReactNode;
  description?: React.ReactNode;
}

export function FormDialog({
  open,
  onOpenChange,
  title,
  description,
  children,
  footer,
}: FormDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>
        {children}
        <DialogFooter>{footer}</DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
